// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__IxTI5","layout":"_styles_layout__SCysT","layout_content":"_styles_layout_content__Aji-P","layout_content_main":"_styles_layout_content_main__RgwaG"};